const $heroes = $('.hero--slider');

$heroes.each(function initHeroSlider() {
  const $hero = $(this);
  const $slides = $hero.find('.hero_slide');
  const interval = parseInt($hero.attr('data-slide-interval'), 10) || 10000;
  const initialDelay = Math.round(interval * 0.8);
  const transitionMs = 10000;
  let currentIndex = 0;
  let timer = null;
  let isTransitioning = false;

  if ($slides.length < 2) {
    return;
  }

  function finishTransition($outgoing, $incoming) {
    $outgoing.removeClass('is-leaving is-entering');
    $incoming.removeClass('is-entering');
    isTransitioning = false;
  }

  function goToSlide(index) {
    if (index === currentIndex || isTransitioning) {
      return;
    }

    isTransitioning = true;

    const $outgoing = $slides.eq(currentIndex);
    const $incoming = $slides.eq(index);

    $outgoing.removeClass('is-active is-entering').addClass('is-leaving');
    $incoming.removeClass('is-leaving').addClass('is-active is-entering');

    currentIndex = index;
    window.setTimeout(() => finishTransition($outgoing, $incoming), transitionMs);
  }

  function scheduleNext(delay) {
    clearTimeout(timer);
    timer = window.setTimeout(() => {
      goToSlide((currentIndex + 1) % $slides.length);
      scheduleNext(interval);
    }, delay);
  }

  function startTimer(useInitialDelay = false) {
    scheduleNext(useInitialDelay ? initialDelay : interval);
  }

  function stopTimer() {
    clearTimeout(timer);
    timer = null;
  }

  $hero.on('mouseenter', stopTimer);
  $hero.on('mouseleave', () => startTimer(false));

  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    startTimer(true);
  }
});
